var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center cursor-pointer"},[_c('the-btn',{staticClass:"btn-primary btn-sm",nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_c('span',{staticClass:"d-lg-none mr-1"},[_vm._v("Edytuj")]),_c('a-icon',{staticStyle:{"color":"white"},attrs:{"icon":'Edit'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }